import React from 'react'

interface IconProps {
  color?: string
  size?: number | string
}

export const ErrorIcon: React.FC<IconProps> = React.memo(({ color = '#F92B50', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
      <path d="M12 13V7" stroke={color} strokeWidth="2" />
      <path d="M12 17V15" stroke={color} strokeWidth="2" />
    </svg>
  )
})

export const ShieldCheckIcon: React.FC<IconProps> = React.memo(
  ({ color = '#1CEF4B', size = 24 }) => {
    return (
      <svg
        width={size}
        height={(Number(size) / 24) * 24 || '24px'} // 保持原始比例
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 4.94444L12 4L19 4.94444V12.0244C19 14.6838 17.6785 17.1692 15.474 18.6564L12 21L8.52603 18.6564C6.32145 17.1692 5 14.6838 5 12.0244V4.94444Z"
          stroke={color}
          strokeWidth="2"
        />
        <path d="M8 11L11 14L16 9" stroke={color} strokeWidth="2" />
      </svg>
    )
  },
)

export const EventDropIcon: React.FC<IconProps> = React.memo(({ color = '#AE4CFF', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.499 4.90635L11.4978 4.90704C11.4991 4.90771 11.5015 4.90833 11.5032 4.9095C11.512 4.91545 11.5282 4.92602 11.5505 4.94039C11.596 4.96969 11.6688 5.01552 11.7663 5.07098C11.9624 5.18259 12.2573 5.33459 12.6313 5.48374C13.3828 5.78337 14.4337 6.06258 15.6526 6.00312C17.2303 5.92623 18.5718 6.28814 19.5126 6.66335C19.984 6.85137 20.3614 7.04502 20.6248 7.19491C20.7567 7.26994 20.8613 7.33559 20.9353 7.38325C20.9721 7.40695 21.0022 7.42661 21.0239 7.44135C21.0344 7.44851 21.0435 7.4548 21.0503 7.45957C21.0537 7.4619 21.0573 7.46442 21.0597 7.46612C21.0608 7.46679 21.0624 7.46746 21.0632 7.46807L21.0649 7.46952C21.0639 7.47153 21.0377 7.50922 20.4848 8.28365L21.0658 7.46977L21.6302 7.87273L19.138 17.1735L17.9679 16.3373L17.9676 16.3383C17.967 16.3378 17.964 16.3359 17.9599 16.3332C17.9513 16.3273 17.9353 16.3158 17.9128 16.3013C17.8674 16.2721 17.7943 16.2271 17.6968 16.1717C17.5007 16.0601 17.2061 15.9072 16.8321 15.758C16.0807 15.4583 15.0297 15.1792 13.8108 15.2386C12.2331 15.3156 10.8914 14.9545 9.95049 14.5793C9.83258 14.5323 9.72013 14.4847 9.61437 14.4377L8.34782 19.1645L6.41597 18.6469L9.83395 5.89079L9.83678 5.89155L10.3251 4.06912L11.499 4.90635ZM18.7712 8.52108C18.0198 8.22143 16.9691 7.9414 15.7502 8.00075C14.1725 8.07772 12.8307 7.71665 11.8899 7.34147C11.7729 7.29483 11.6616 7.2472 11.5566 7.2006L10.1434 12.4745C10.2993 12.552 10.483 12.6383 10.6919 12.7216C11.4434 13.0212 12.4943 13.3004 13.7132 13.241C15.291 13.164 16.6324 13.526 17.5732 13.9012C17.6901 13.9478 17.8018 13.9945 17.9068 14.0411L19.3199 8.7672C19.1641 8.68969 18.9801 8.6044 18.7712 8.52108Z"
        fill={color}
      />
      <path
        opacity="0.6"
        d="M7.08014 5.43294L7.07895 5.43363C7.08009 5.43442 7.08249 5.43494 7.08435 5.43609C7.093 5.44197 7.10922 5.45249 7.13168 5.46697C7.17711 5.49623 7.24982 5.54202 7.34742 5.59757C7.54354 5.70916 7.83838 5.86112 8.21245 6.01033C8.46124 6.10954 8.74356 6.20401 9.05324 6.28717L8.5356 8.21903C8.1408 8.11308 7.78343 7.99265 7.47102 7.86806C7.35428 7.82149 7.24352 7.77397 7.13867 7.72744L5.72552 13.0014C5.88128 13.0788 6.0644 13.1649 6.27308 13.2482C6.52186 13.3474 6.80419 13.4418 7.11386 13.525L6.59622 15.4569C6.20142 15.3509 5.84406 15.2305 5.53165 15.1059C5.4149 15.0593 5.30413 15.0119 5.19929 14.9653L3.93275 19.6921L2.0009 19.1745L3.4153 13.8958L3.41436 13.8956L5.90625 4.5957L7.08014 5.43294Z"
        fill={color}
      />
    </svg>
  )
})
